function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "4.9775391mm",
    height: "7.7216802mm",
    viewBox: "0 0 4.9775391 7.7216802",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64.548992,-58.170486)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 67.118328,61.701736 q 0.654296,-0.214843 0.991211,-0.576171 0.336914,-0.366211 0.336914,-0.854493 0,-0.517578 -0.34668,-0.815429 -0.34668,-0.302735 -0.952149,-0.302735 -0.629882,0 -1.010742,0.332032 -0.380859,0.327148 -0.380859,0.874023 0,0.498047 0.341797,0.834961 0.346679,0.332031 1.020508,0.507812 z m -0.322266,0.590821 q -0.585938,0.258789 -0.864258,0.610351 -0.273437,0.34668 -0.273437,0.830078 0,0.527344 0.366211,0.84961 0.371093,0.317383 0.971679,0.317383 0.634766,0 1.030274,-0.361328 0.40039,-0.361329 0.40039,-0.927735 0,-0.46875 -0.366211,-0.766601 -0.361328,-0.302735 -1.264648,-0.551758 z m 1.040039,-0.332031 q 0.737305,0.219726 1.083984,0.605468 0.34668,0.38086 0.34668,0.976563 0,0.917969 -0.65918,1.508789 -0.654296,0.59082 -1.689453,0.59082 -0.957031,0 -1.538086,-0.50293 -0.581054,-0.502929 -0.581054,-1.328125 0,-0.600585 0.336914,-1.040039 0.336914,-0.444336 1.000976,-0.717773 -0.620117,-0.27832 -0.932617,-0.698242 -0.307617,-0.424805 -0.307617,-1.00586 0,-0.859375 0.634766,-1.391601 0.639648,-0.53711 1.674804,-0.53711 0.947266,0 1.508789,0.473633 0.561524,0.473633 0.561524,1.264649 0,0.615234 -0.361328,1.069336 -0.356446,0.449218 -1.079102,0.732422 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit8);
export default __webpack_public_path__ + "static/media/digit-8.3358e69f5e3e0062d736cbd638df2c9d.svg";
export { ForwardRef as ReactComponent };